import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";
import { WinnersHeaderBlue } from "../View/WinnersHome/WinnerBlueLan/WinnersHeaderBlue";

const PrivacyPolicy = () => {
  return (
    <main className="ws-privacy-page">
       <WinnersHeaderBlue/>

      {/* ================= HERO ================= */}
      <section className="ws-privacy-hero">
        <div className="ws-privacy-container">
          <span className="ws-privacy-eyebrow">
            WINNERS
          </span>

          <h1>Privacy Policy</h1>

          <p>
            Your privacy matters to us. This Privacy Policy explains
            how Winners.in collects, uses and protects your
            information when you use our website and services.
          </p>

          <span className="ws-privacy-date">
            Last Updated: August 13, 2026
          </span>
        </div>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="ws-privacy-content">
        <div className="ws-privacy-document">

          {/* 01 */}
          <section>
            <span className="ws-section-number">01</span>

            <h2>Introduction</h2>

            <p>
              Winners.in ("Winners.in", "we", "us" or
              "our") respects your privacy and is committed to
              protecting your personal information.
            </p>

            <p>
              This Privacy Policy explains what information we
              collect, how we use it, how we protect it and the
              choices available to you when you use our website
              or contact us.
            </p>
          </section>

          {/* 02 */}
          <section>
            <span className="ws-section-number">02</span>

            <h2>Information We Collect</h2>

            <p>
              Depending on how you interact with our website,
              we may collect:
            </p>

            <ul>
              <li>Name and contact details.</li>
              <li>Email address and phone number.</li>
              <li>Property preferences and requirements.</li>
              <li>Information submitted through enquiry forms.</li>
              <li>Communication records when you contact us.</li>
              <li>Website usage and technical information.</li>
              <li>Device and browser information.</li>
            </ul>
          </section>

          {/* 03 */}
          <section>
            <span className="ws-section-number">03</span>

            <h2>How We Use Your Information</h2>

            <p>
              We may use the information we collect to:
            </p>

            <ul>
              <li>Respond to your property enquiries.</li>
              <li>Provide information about properties and projects.</li>
              <li>Contact you regarding your enquiry.</li>
              <li>Improve our website and services.</li>
              <li>Provide customer support.</li>
              <li>Maintain website security.</li>
              <li>Send relevant updates and promotional communications.</li>
              <li>Comply with applicable legal requirements.</li>
            </ul>
          </section>

          {/* 04 */}
          <section>
            <span className="ws-section-number">04</span>

            <h2>Property Information</h2>

            <p>
              Property prices, availability, specifications,
              images and other project information may change
              from time to time.
            </p>

            <p>
              We recommend independently verifying important
              property information, approvals, ownership,
              pricing and other relevant documents before making
              any property or investment decision.
            </p>
          </section>

          {/* 05 */}
          <section>
            <span className="ws-section-number">05</span>

            <h2>Cookies</h2>

            <p>
              Our website may use cookies and similar technologies
              to improve website functionality, understand visitor
              activity and provide a better user experience.
            </p>

            <p>
              You can manage or disable cookies through your
              browser settings. Some website features may not
              function properly if cookies are disabled.
            </p>
          </section>

          {/* 06 */}
          <section>
            <span className="ws-section-number">06</span>

            <h2>Sharing of Information</h2>

            <p>
              We may share information where reasonably necessary
              to provide our services or operate our business.
              This may include:
            </p>

            <ul>
              <li>Property owners or developers.</li>
              <li>Real estate partners or service providers.</li>
              <li>Website and technology service providers.</li>
              <li>Email and communication service providers.</li>
              <li>Professional advisers where appropriate.</li>
              <li>Government or regulatory authorities where required by law.</li>
            </ul>

            <p>
              We do not intend to sell your personal information
              merely because you submit an enquiry.
            </p>
          </section>

          {/* 07 */}
          <section>
            <span className="ws-section-number">07</span>

            <h2>Data Security</h2>

            <p>
              We take reasonable technical and organisational
              measures to protect your information from
              unauthorised access, misuse, alteration or disclosure.
            </p>

            <p>
              However, no method of electronic transmission or
              storage can be guaranteed to be completely secure.
            </p>
          </section>

          {/* 08 */}
          <section>
            <span className="ws-section-number">08</span>

            <h2>Data Retention</h2>

            <p>
              We retain personal information only for as long as
              reasonably necessary for the purpose for which it was
              collected, legitimate business requirements and
              applicable legal obligations.
            </p>
          </section>

          {/* 09 */}
          <section>
            <span className="ws-section-number">09</span>

            <h2>Your Rights</h2>

            <p>
              Subject to applicable law, you may have the right to:
            </p>

            <ul>
              <li>Request access to your personal information.</li>
              <li>Request correction of inaccurate information.</li>
              <li>Request deletion where legally permitted.</li>
              <li>Withdraw consent where applicable.</li>
              <li>Raise a privacy-related grievance.</li>
            </ul>

            <p>
              Requests may be subject to reasonable verification
              and applicable legal requirements.
            </p>
          </section>

          {/* 10 */}
          <section>
            <span className="ws-section-number">10</span>

            <h2>Third-Party Websites</h2>

            <p>
              Our website may contain links to third-party websites
              or services. We are not responsible for the privacy
              practices, content or security of those websites.
            </p>

            <p>
              We recommend reviewing the privacy policy of any
              third-party website before submitting your information.
            </p>
          </section>

          {/* 11 */}
          <section>
            <span className="ws-section-number">11</span>

            <h2>Children's Privacy</h2>

            <p>
              Our services are primarily intended for adults.
              We do not knowingly collect personal information
              from children for purposes prohibited by applicable law.
            </p>
          </section>

          {/* 12 */}
          <section>
            <span className="ws-section-number">12</span>

            <h2>Changes to This Privacy Policy</h2>

            <p>
              We may update this Privacy Policy from time to time
              to reflect changes in our services, technology,
              business practices or applicable laws.
            </p>

            <p>
              Any updated version will be published on this page
              with a revised "Last Updated" date.
            </p>
          </section>

          {/* 13 */}
          <section>
            <span className="ws-section-number">13</span>

            <h2>Contact Us</h2>

            <p>
              If you have any questions, requests or concerns
              regarding this Privacy Policy, please contact us.
            </p>

            <div className="ws-privacy-contact">

              <div className="ws-privacy-contact-item">
                <span>Email</span>

                <a href="mailto:thewinners2ncr@gmail.com">
                  thewinners2ncr@gmail.com
                </a>
              </div>

              <div className="ws-privacy-contact-item">
                <span>Phone</span>

                <a href="tel:+918009903561">
                  +91-8009903561
                </a>
              </div>

              <div className="ws-privacy-contact-item">
                <span>Address</span>

                <p>
                  G-9 Garden,
                  <br />
                  East Delhi, India
                </p>
              </div>

            </div>
          </section>

          {/* ================= BOTTOM ================= */}
          <div className="ws-privacy-bottom">

            <div>
              <span>Winners.in</span>

              <h3>
                Have questions about your privacy?
              </h3>

              <p>
                Contact our team via Email or Call and we'll be happy to assist you.
              </p>
            </div>

            {/* <Link to="/contact-us">
              Contact Us
            </Link> */}
            <a href="#contact-us-section">
              Contact Us
            </a>

          </div>

        </div>
      </section>

    </main>
  );
};

export default PrivacyPolicy;